import React, {useEffect, useState} from "react";
import {FormControl, FormGroup, InputGroup} from "react-bootstrap";

const CPSettingSize = ({
    name,
    label,
    eventValue,
    defaultValue,
    onChange,
    isNumericalSize = false,
    hint = '',
    minValue = 0,
}) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(eventValue || defaultValue);
    }, [eventValue]);

    const handleChange = (value) => {
        let size = parseFloat(value.replace(/[^\d\+\.]/g, ''));
        size = (size < minValue ? minValue : size);
        size = isNumericalSize ? size : `${size}px`;

        setValue(size);
        onChange({[name]: size});
    };

    return (
        <FormGroup>
            <FormGroup style={{marginBottom: '8px'}}>
                <InputGroup>
                    <InputGroup.Addon>{label}</InputGroup.Addon>
                    <FormControl
                        value={value}
                        type="text"
                        name={name}
                        onChange={(e) => setValue(e.target.value)}
                        onBlur={(e) => handleChange(e.target.value)}
                    />
                </InputGroup>
            </FormGroup>
            {
                !!hint &&
                <p>
                    <i>
                        ({hint})
                    </i>
                </p>
            }
        </FormGroup>
    );
};

export default CPSettingSize;
